import CityPageTemplate from "../city-template/CityPageTemplate";
import { manassasVaConfig } from "./data";

export default function ManassasVaPage() {
  return <CityPageTemplate config={manassasVaConfig} />;
}